var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    staticClass: "field-custom-label",
    attrs: {
      "name": "degree",
      "items": _vm.computedDegreeItems,
      "placeholder": "Select your degree",
      "label": "Select your degree",
      "height": "56",
      "background-color": "var(--v-background-base)",
      "dense": "",
      "outlined": "",
      "solo": "",
      "flat": "",
      "autocapitalize": "sentences",
      "autocomplete": "degree",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('label', {
          staticClass: "text text-m-small-bold"
        }, [_vm._v("Degree *")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.degree,
      callback: function ($$v) {
        _vm.degree = $$v;
      },
      expression: "degree"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }